import React, { useState } from "react";
import { useFilloutEmbed } from "../embed.js";
import { Loading } from "../components/Loading.js";
export const FullScreen = ({ filloutId, domain, inheritParameters, parameters, }) => {
    const [loading, setLoading] = useState(true);
    const embed = useFilloutEmbed({
        filloutId,
        domain,
        inheritParameters,
        parameters,
    });
    return (React.createElement("div", { style: {
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
        } },
        loading && (React.createElement("div", { style: {
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
                height: "100%",
            } },
            React.createElement(Loading, null))),
        embed && (React.createElement("iframe", { src: embed.iframeUrl, allow: "microphone; camera; geolocation", title: "Embedded Form", style: {
                border: 0,
                width: !loading ? "100%" : 0,
                height: !loading ? "100%" : 0,
                opacity: !loading ? 1 : 0,
            }, onLoad: () => setLoading(false) }))));
};
